import { useQuery } from 'react-query';

import { useConfigurationStore } from 'store/configurationsStore';

import { getComponentsConfiguration as queryFn } from 'api/endPoints/getConfigurations';

export const useQueryGetComponentsConfiguration = () => {
    const { update: updateWidgetsConfigurations } = useConfigurationStore();
    return useQuery({
        queryKey: ['getComponentsConfiguration'],
        queryFn,
        onSuccess: (data) => {
            updateWidgetsConfigurations(data);
        },
    });
};
